export const ADMIN_MIGRATION_MACRO_USAGE_FF = 'confluence.frontend.admin.migration.macro-usage';
export const ADMIN_MIGRATION_SPACE_SETTINGS_FF =
	'confluence.frontend.admin.migration.space-settings-migrations';
